import { render } from "./ToggleSettingsButton.vue?vue&type=template&id=5540073e"
import script from "./ToggleSettingsButton.vue?vue&type=script&lang=js"
export * from "./ToggleSettingsButton.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/estate-boost-frontend/estate-boost-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__